import { HTMLAttributes } from 'react'
import { classNames } from '../../lib/classNames/classNames'
import cls from './Container.module.scss'

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {}

export const Container = ({ className, ...rest }: ContainerProps) => {
    return <div className={classNames(cls.root, {}, [className])} {...rest} />
}

